<template>
  <div class="lb">
    <div
      ref="barMian"
      class="barMian"
      @mouseover="autoTimePaused = true"
      @mouseout="autoTimePaused = false"
    ></div>
  </div>
</template>

<script>
import * as methods from "./method.js";
export default {
  name: "template.scope96",
  props: {
    vdata: {
      type: [Array, String],
      default: () => [],
    },
    jsondata: {
      type: [Array, String],
      default: () => [],
    },
    scopedata: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: "scope96-【组件】多柱图横轴",
      timer: null,
      defaultdata: [
        {
          value1: "A1.教育舆情",
          value2: "舆情潜伏期",
          value3: "60",
          value4: "舆情发酵期",
          value5: "-30",
          value6: "舆情爆发期",
          value7: "60",
          value8: "舆情反复时长",
          value9: "70",
          value10: "舆情衰退期",
          value11: "120",
          value12: "爆点时长",
          value13: "80",
          value14: "首爆可控期",
          value15: "120",
          // value16: "天",
        },
        {
          value1: "A2.卫健舆情",
          value2: "舆情潜伏期",
          value3: "60",
          value4: "舆情发酵期",
          value5: "-30",
          value6: "舆情爆发期",
          value7: "60",
          value8: "舆情反复时长",
          value9: "70",
          value10: "舆情衰退期",
          value11: "120",
          value12: "爆点时长",
          value13: "80",
          value14: "首爆可控期",
          value15: "120",
        },
        {
          value1: "A3.政务-政府部门舆情",
          value2: "舆情潜伏期",
          value3: "60",
          value4: "舆情发酵期",
          value5: "-30",
          value6: "舆情爆发期",
          value7: "60",
          value8: "舆情反复时长",
          value9: "70",
          value10: "舆情衰退期",
          value11: "120",
          value12: "爆点时长",
          value13: "80",
          value14: "首爆可控期",
          value15: "120",
        },
        {
          value1: "A4.政务-公共事件舆情",
          value2: "舆情潜伏期",
          value3: "60",
          value4: "舆情发酵期",
          value5: "-30",
          value6: "舆情爆发期",
          value7: "60",
          value8: "舆情反复时长",
          value9: "70",
          value10: "舆情衰退期",
          value11: "120",
          value12: "爆点时长",
          value13: "80",
          value14: "首爆可控期",
          value15: "120",
        },
        {
          value1: "A5.政务-案事件舆情",
          value2: "舆情潜伏期",
          value3: "60",
          value4: "舆情发酵期",
          value5: "-30",
          value6: "舆情爆发期",
          value7: "60",
          value8: "舆情反复时长",
          value9: "70",
          value10: "舆情衰退期",
          value11: "120",
          value12: "爆点时长",
          value13: "80",
          value14: "首爆可控期",
          value15: "120",
        },
        {
          value1: "A6.企业舆情",
          value2: "舆情潜伏期",
          value3: "60",
          value4: "舆情发酵期",
          value5: "-30",
          value6: "舆情爆发期",
          value7: "60",
          value8: "舆情反复时长",
          value9: "70",
          value10: "舆情衰退期",
          value11: "120",
          value12: "爆点时长",
          value13: "80",
          value14: "首爆可控期",
          value15: "120",
        },
        {
          value1: "B1.高速舆情",
          value2: "舆情潜伏期",
          value3: "60",
          value4: "舆情发酵期",
          value5: "-30",
          value6: "舆情爆发期",
          value7: "60",
          value8: "舆情反复时长",
          value9: "70",
          value10: "舆情衰退期",
          value11: "120",
          value12: "爆点时长",
          value13: "80",
          value14: "首爆可控期",
          value15: "120",
        },
        {
          value1: "C2.待分类舆情",
          value2: "舆情潜伏期",
          value3: "60",
          value4: "舆情发酵期",
          value5: "-30",
          value6: "舆情爆发期",
          value7: "60",
          value8: "舆情反复时长",
          value9: "70",
          value10: "舆情衰退期",
          value11: "120",
          value12: "爆点时长",
          value13: "80",
          value14: "首爆可控期",
          value15: "120",
        },
      ],
      valueMap: [
        { name: "名称", key: "value1" },
        { name: "柱状图一图例", key: "value2" },
        { name: "柱状图一数据", key: "value3" },
        { name: "柱状图二图例", key: "value4" },
        { name: "柱状图二数据", key: "value5" },
        { name: "柱状图三图例", key: "value6" },
        { name: "柱状图三数据", key: "value7" },
        { name: "柱状图四图例", key: "value8" },
        { name: "柱状图四数据", key: "value9" },
        { name: "柱状图五图例", key: "value10" },
        { name: "柱状图五数据", key: "value11" },
        { name: "柱状图六图例", key: "value12" },
        { name: "柱状图六数据", key: "value13" },
        { name: "柱状图七图例", key: "value14" },
        { name: "柱状图七数据", key: "value15" },

        // { name: "单位", key: "value4" },
      ],
      exceldata: [],
      apiconfig: {},
      isApi: false,
      scope: {},
      autoTimePaused: false,
    };
  },
  watch: {
    vdata(n) {
      if (n && n.length) {
        this.defaultdata = n;
      }
    },
    jsondata(n) {
      this.exceldata = n;
    },
    defaultdata(n) {
      this.DrawEcharts();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    ...methods,
    DrawEcharts() {
      clearInterval(this.timer);
      this.timer = null;
      var echarts = require("echarts");
      var TmyChart = echarts.init(this.$refs.barMian);
      const colormap = [
        "#3792e0",
        "#ff6660",
        "#6ce2fe",
        "#82f2fe",
        "#fafcff",
        "#74feae",
        "#6c91c4",
      ];
      let vdata = JSON.parse(JSON.stringify(this.defaultdata));
      const dataKeys = [
        ["value2", "value3"],
        ["value4", "value5"],
        ["value6", "value7"],
        ["value8", "value9"],
        ["value10", "value11"],
        ["value12", "value13"],
        ["value14", "value15"],
      ];
      const seriesData = [];
      const legendData = [];
      const xData = [...new Set(vdata.map((item) => item.value1))];

      dataKeys.forEach(([legendKey, dataKey]) => {
        const currentData = [];
        vdata.forEach((item) => {
          if (item[legendKey] && (item[dataKey] || item[dataKey] === 0)) {
            currentData.push(Number(item[dataKey]));
            if (!legendData.includes(item[legendKey])) {
              legendData.push(item[legendKey]);
            }
          }
        });
        seriesData.push(currentData);
      });

      const percent = (8 / xData.length) * 100;
      let zoom = [
        {
          id: "scope96", // 唯一的id
          type: 'slider',
					moveHandleSize: 0,
					showDetail: false, //关闭：拖拽时候显示详细数值信息。	
          dataBackground: {
						show: false,
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					selectedDataBackground: {
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
          backgroundColor: "transparent",
          fillerColor:"rgba(0,0,0,.2)",
          borderColor:"transparent",
          start: 0,
          brushSelect: false,
          end: percent
        },
      ];
      const legend = {
        show: true,
        top: "2%",
        // left: "50%",
        itemHeight: 12, //图例的高度  文字左边那个
        itemWidth: 10,
        itemGap: 10, // 设置图例项之间的间隔
        icon: "rect",
        textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
        data: legendData,
      };

      const series = seriesData.map((data, index) => {
        const formattedData = data.map((value) => ({
          value,
          label: {
            normal: {
              show: true,
              position: value >= 0 ? "top" : "bottom",
              color: colormap[index],
            },
          },
          itemStyle: {
            color: new echarts.graphic.LinearGradient(
              0,
              value >= 0 ? 0 : 1,
              0,
              value >= 0 ? 1 : 0,
              [
                { offset: 0.5, color: colormap[index] },
                { offset: 1, color: "rgba(0,0,0,.2)" },
              ],
              false
            ),
          },
        }));

        return {
          name: legendData[index],
          type: "bar",
          barWidth: 15,
          barGap: "40%",
          data: formattedData,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                { offset: 0, color: colormap[index] },
                { offset: 1, color: "rgba(0,0,0,.2)" },
              ],
              false
            ),
          },
        };
      });
      var Toption = {
        tooltip: {
          trigger: "item",
        },
        legend,
        grid: {
          left: "5px",
          right: "20px",
          bottom: "10px",
          top: "40px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisLabel: {
            interval: 0,
            top: "20px",
            width: 150,
            overflow: 'truncate', //文字超出宽度截断，默认为...
            overflow: "truncate", //文字超出宽度截断 换行
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
              fontSize: "14",
              lineHeight: 16,
            },
          },
          axisLine: {
            lineStyle: {
              // X 轴颜色配置
              color: "#4792e9",
            },
          },
          axisTick: {
            show: false,
          },

          data: xData,
        },
        yAxis: {
          type: "value",
          z: 10,
          splitNumber: 3,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "rgba(231,241,251,.2)",
            },
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
            },
          },
        },
        series,
        dataZoom: xData.length > 8 ? zoom : [],
      };
      Toption && TmyChart.setOption(Toption);
      this.timer = setInterval(() => {
        if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
        TmyChart.clear();
        Toption && TmyChart.setOption(Toption);
      }, 5000);
    },
  },
  created() {},
  mounted() {
    if (this.vdata && this.vdata.length) {
      this.defaultdata = this.vdata;
    }
    if (this.jsondata && this.jsondata.length) {
      this.exceldata = this.jsondata;
    }
    this.DrawEcharts();
    this.setData(); //需要刷新的数据
  },
};
</script>

<style scoped>
.lb {
  width: 1836px;
  height: 240px;
  display: flex;
  overflow: hidden;
  position: relative;
  padding: 10px 0;
}

.barMian {
  width: 100%;
  height: 100%;
}
</style>
